import styled from "styled-components";

import PButton from "../../../../components/PButton";

export const Container = styled.div`
  flex: 1;
`;

export const TitleWrap = styled.div`
  text-transform: capitalize;

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 560px) {
    padding-top: 30px;
  }
`;

export const TitleFirst = styled.div`
  position: relative;
  width: fit-content;
  margin: auto;
  /* white-space: nowrap; */
  margin-top: 20px;
`;

export const TitleSecond = styled.div`
  position: relative;
  width: fit-content;
  margin: auto;
`;

export const TitleText = styled.div`
  font-family: "Lora Medium";
  font-size: 40px;
  color: ${({ theme }) => theme.colors.blackGreen};
  margin-top: -52px;
  padding-left: 6px;
  padding-right: 12px;
  padding-bottom: 10px;

  &>span {
  background-image: linear-gradient(#fff 50%, rgba(214, 213, 213, .4) 0%);
  display: inline;
  background-position: right 0px bottom 2px;
  color: black;
}


  @media only screen and (max-width: 768px) {
    font-size: 40px;
  }
  @media only screen and (max-width: 560px) {
    font-size: 27px;
    text-align: center;
  }
`;

export const BgColorDiv = styled.div`
  height: 24px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightGray2};

  @media only screen and (max-width: 768px) {
    height: 20px;
    margin-bottom: 0px;
  }
  @media only screen and (max-width: 560px) {
    height: 20px;
    margin-bottom: 10px;
  }
`;

export const SummaryContainer = styled.div`
  ${({ theme }) => theme.textStyles.content2}
  font-family: "Helvetica";
  /* padding-left: 10px; */
  /* padding-right: 100px; */
  padding-top: 0px;
  padding-bottom: 0px;
  text-align: center;

  @media only screen and (max-width: 768px) {
    padding-right: 10px;
    font-size: 20px;
  }
  
  @media only screen and (max-width: 560px) {
    padding-top: 30px;
    padding-right: 10px;
    font-size: 14px;
  }
`;

export const ButtonWrap = styled.div`
  /* margin-left: auto;
  margin-right: auto; */
  margin-top: -25px;
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
  @media only screen and (max-width: 768px) {
    padding-left: 0px;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
  }
`;

export const MoreButton = styled(PButton)`
  padding-left: ${({ theme }) => theme.spacings.spacing_xxl_m};
  padding-right: ${({ theme }) => theme.spacings.spacing_xxl_m};
  border-radius: 0;
  border: solid 2px ${({ theme }) => theme.colors.prune};
  & span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.prune};
  }

  @media only screen and (max-width: 768px) {
    height: 60px;
    & span {
      font-size: 16px;
    }
  }

  @media only screen and (max-width: 560px) {
    height: 46px;
    & span {
      font-size: 14px;
    }
  }
`;

export const GalleryContainer = styled.div`
display: block;
width: 100%;
/* height: 500px; */
`;
